import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "./auth";

export function Shell({ children }: { children: React.ReactNode }) {
  const [now, setNow] = useState<Date>(new Date());
  const { me, signOut, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="app">
      <header className="topbar">
        <Link to="/" className="logo" aria-label="Lighthouse home">
          <span className="logo-text">
            <span className="logo-name">
              <span className="lw-light">Light</span>
              <span className="lw-house">house</span>
            </span>
            <span className="logo-by">by Thinking Fish</span>
          </span>
        </Link>
        {me?.is_superuser && (
          <button
            onClick={() => navigate("/users")}
            style={{ color: "var(--text-1)", fontSize: 13, padding: "5px 11px", borderRadius: 999, border: "1px solid var(--border)" }}
          >
            Users
          </button>
        )}
        <div className="spacer" />
        <div className="env-pill">
          <span className="dot ok live" /> Live ·{" "}
          <span style={{ fontFamily: "var(--font-mono)", fontSize: 11 }}>
            {now.toLocaleTimeString("en-GB")}
          </span>
        </div>
        <div className="env-pill">EU-West</div>
        {!loading && me && (
          <button
            onClick={signOut}
            title={me.email}
            className="avatar"
            style={{ cursor: "pointer" }}
          >
            {(me.email[0] || "?").toUpperCase()}
          </button>
        )}
      </header>
      <main className="main">{children}</main>
    </div>
  );
}
